import api from './index';
//
let exports = {};

// 物流查询
exports.getTraceInfo = function (params, callback) {
    api.get('/logis/trace/info/get')
    .params(params)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/logis.js
// module id = 1000
// module chunks = 0